module.exports = "./assets/images/avatar-2.svg";